module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-06-15",
		"endpointPrefix": "sts",
		"globalEndpoint": "sts.amazonaws.com",
		"protocol": "query",
		"serviceAbbreviation": "AWS STS",
		"serviceFullName": "AWS Security Token Service",
		"signatureVersion": "v4",
		"uid": "sts-2011-06-15",
		"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
	},
	"operations": {
		"AssumeRole": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					},
					"ExternalId": {},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"AssumeRoleWithSAML": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"PrincipalArn",
					"SAMLAssertion"
				],
				"members": {
					"RoleArn": {},
					"PrincipalArn": {},
					"SAMLAssertion": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithSAMLResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Subject": {},
					"SubjectType": {},
					"Issuer": {},
					"Audience": {},
					"NameQualifier": {}
				}
			}
		},
		"AssumeRoleWithWebIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName",
					"WebIdentityToken"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"WebIdentityToken": {},
					"ProviderId": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithWebIdentityResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"SubjectFromWebIdentityToken": {},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Provider": {},
					"Audience": {}
				}
			}
		},
		"DecodeAuthorizationMessage": {
			"input": {
				"type": "structure",
				"required": [
					"EncodedMessage"
				],
				"members": {
					"EncodedMessage": {}
				}
			},
			"output": {
				"resultWrapper": "DecodeAuthorizationMessageResult",
				"type": "structure",
				"members": {
					"DecodedMessage": {}
				}
			}
		},
		"GetCallerIdentity": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "GetCallerIdentityResult",
				"type": "structure",
				"members": {
					"UserId": {},
					"Account": {},
					"Arn": {}
				}
			}
		},
		"GetFederationToken": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "GetFederationTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"FederatedUser": {
						"type": "structure",
						"required": [
							"FederatedUserId",
							"Arn"
						],
						"members": {
							"FederatedUserId": {},
							"Arn": {}
						}
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"GetSessionToken": {
			"input": {
				"type": "structure",
				"members": {
					"DurationSeconds": {
						"type": "integer"
					},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "GetSessionTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"AccessKeyId",
				"SecretAccessKey",
				"SessionToken",
				"Expiration"
			],
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {},
				"Expiration": {
					"type": "timestamp"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"AssumedRoleId",
				"Arn"
			],
			"members": {
				"AssumedRoleId": {},
				"Arn": {}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/sts-2011-06-15.min.json
// module id = 1415
// module chunks = 0